import React, {Component} from "react";
import Error from "../components/common/Error";

export default (WrappedComponent) =>
  class ErrorBoundary extends Component {
    state = {error: null, errorInfo: null};
    componentDidCatch = (error, errorInfo) => catchFunc(error, errorInfo, this);
    render() {
      if (this.state.errorInfo) {
        return <Error message={this.state.error.message} />;
      }
      return <WrappedComponent {...this.props} />;
    }
  };

const catchFunc = (error, errorInfo, ctx) => {
  ctx.setState({
    error,
    errorInfo
  });
};
